var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{class:_vm.styles,attrs:{"disabled":!_vm.deleteActiveCondition,"flat":"","small":"","icon":"","color":"red"},on:{"click":_vm.switchHandler}},[_c('v-icon',[_vm._v("delete_forever")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }